module.exports = __webpack_public_path__ + "img/theme-e.abcd95d7.png";